exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pointer-cursor[_v-22804018]{cursor:pointer}.full-height[_v-22804018]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:.71428571em;vertical-align:middle}.padding[_v-22804018]{padding:.71428571em}", "", {"version":3,"sources":["/./src/components/PlainText.vue"],"names":[],"mappings":"AAkHA,6BACE,cAAgB,CACjB,AACD,0BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,oBAAsB,AACtB,qBAAuB,CACxB,AACD,sBACE,mBAAsB,CACvB","file":"PlainText.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.pointer-cursor[_v-22804018] {\n  cursor: pointer;\n}\n.full-height[_v-22804018] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0.71428571em;\n  vertical-align: middle;\n}\n.padding[_v-22804018] {\n  padding: 0.71428571em;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-22804018&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/PlainText.vue
 ** module id = 159
 ** module chunks = 0
 **/